// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5746":"7d4f7fe3a73ddfbf","7086":"eb63916c18102d5e"}[chunkId] + ".js";
};